@import "../../styles/InputMixins";

:host {
  display: block;
}

.inputLabel {
  @include input-label;
}

.phoneNumberInput {
  @include input-control;
  position: relative;
  display: flex;
  flex-direction: row;
  min-height: 48px;
  padding: 0;
  overflow: hidden;
}

.phoneCountrySelector {
  position: relative;
  display: flex;
  flex: 0 0 96px;
  align-items: stretch;
  background: #ffffff;
  color: #39393a;
  border-right: 1px solid #c5c5ca;
  border-radius: $input-border-radius 0 0 $input-border-radius;
}

.phoneCountrySelector > select {
  position: absolute;
  z-index: 1;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  appearance: none;
  font-family: $input-font-family;
  font-size: $input-font-size;
  cursor: pointer;
  opacity: 0;
}

.selectedPhoneCountry {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 3px;
  box-sizing: border-box;
  font-family: $input-font-family;
  font-size: $input-font-size;
  padding: 0 4px;
  white-space: nowrap;
}

.selectedCountryFlag {
  font-size: 16px;
  line-height: 24px;
}

.phoneCountryChevron {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  background-color: currentColor;
  -webkit-mask: url("data:image/svg+xml;utf8,<svg height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>") center / 18px 18px no-repeat;
  mask: url("data:image/svg+xml;utf8,<svg height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>") center / 18px 18px no-repeat;
}

.phoneCountrySelector > select:focus,
.phoneNumberInput > input:focus {
  outline: none;
}

.phoneCountrySelector.disabled {
  background-color: var(--srci-phone-country-disabled-background-color, #{$input-disabled-background-color});
  color: var(--srci-phone-country-disabled-text-color, #{$input-disabled-text-color});
  cursor: not-allowed;
}

.phoneNumberInput > input:disabled {
  background-color: var(--srci-input-disabled-background-color, #{$input-disabled-background-color});
  color: var(--srci-input-disabled-text-color, #{$input-disabled-text-color});
  cursor: not-allowed;
}

.phoneCountrySelector > select:disabled {
  cursor: not-allowed;
}

.phoneNumberInput > input {
  width: 100%;
  min-width: 0;
  border: none;
  border-radius: 0 $input-border-radius $input-border-radius 0;
  appearance: none;
  color: #39393a;
  font-family: $input-font-family;
  font-size: $input-font-size;
  padding: 0 12px;
}

.phoneNumberInput[aria-invalid="true"] > input {
  padding-right: 46px;
}

.errorIcon {
  @include input-error-icon;
}

.errorInfo {
  @include input-error;
}
